import React from 'react'
import { Box, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { ObservatoryType, ObservatoryValue } from 'common/types'
import { StyledTableCell } from 'components/ui/StyledTableCell'
import { StyledTableRow } from 'components/ui/StyledTableRow'
import dayjs from 'dayjs'
import { UnderpassChart } from './UnderpassChart'

export const UnderpassDetail = () => {
  const state = useGlobalState()
  const observatory = React.useMemo(() => {
    return state.observatory.selected
  }, [state.observatory.selected])

  const timeSeries: ObservatoryValue[] = React.useMemo(() => {
    if (observatory === null) return []
    if (state.observatory.timeSeries.length === 0) return []
    const minDate = dayjs.utc(state.app.baseDate).subtract(3, 'hours')
    const targets = (state.observatory.timeSeries).filter(ts =>
      ts.date > minDate.format('YYYY/MM/DD HH:mm')
    )
    return targets
  }, [state.observatory.timeSeries])

  const waterBoxLevel: number | null = React.useMemo(() => {
    if (timeSeries.length > 0) {
      const targetValue = timeSeries.findLast(ts => ts.level !== undefined)
      if (targetValue !== undefined && targetValue.level !== undefined) {
        return targetValue.level
      }
    }
    if (observatory === null || state.observatory.observatories.length === 0) return null
    const target = state.observatory.observatories.find(o => o.id === observatory.id && o.type === ObservatoryType.Underpass)
    if (target && target.level !== undefined && target.level !== null) {
      return target.level
    } else {
      return null
    }
  }, [state.observatory.observatories, observatory, timeSeries])

  const getLocalDateFormat = (date: string) => {
    return dayjs.utc(date).local().format('MM/DD HH:mm')
  }

  return ( observatory &&
    <Box>

      <Stack direction="column">
        <Typography variant='caption'>（㎝）</Typography>
        <UnderpassChart height={200} timeSeries={timeSeries} waterBoxLevel={waterBoxLevel} />
      </Stack>

      <Stack direction="row" alignItems={'center'} my={2}>
        <Typography variant='caption'>
          { timeSeries.length === 0 && 'データがありません。'}
        </Typography>
      </Stack>

      { timeSeries.length > 0 && (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{p: 0.5}} width={95}>日時</StyledTableCell>
                <StyledTableCell sx={{p: 0.5}} width={70}>水位 (㎝)</StyledTableCell>
                <StyledTableCell sx={{p: 0.5}} width={70}>
                  <Typography variant='body2' fontSize={14} textAlign={'center'}>状態</Typography>
                </StyledTableCell>
                <StyledTableCell sx={{p: 0.5}}>
                  <Typography variant='body2' fontSize={14} textAlign={'center'}>ポンプ</Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeSeries.map((ts, i) => (
                <StyledTableRow key={i}>
                  <StyledTableCell color={grey[900]} sx={{px: 0.5, py: 1}}>
                    <Typography variant='body2'>{getLocalDateFormat(ts.date)}</Typography>
                  </StyledTableCell>
                  <StyledTableCell color={grey[900]} sx={{px: 0.5, py: 1}}>
                    <Typography variant='body2' textAlign={'end'}>{ts.level === undefined ? '-' : ts.level.toFixed(0)}</Typography>
                  </StyledTableCell>
                  <StyledTableCell color={grey[900]} sx={{px: 0.5, py: 1}}>
                    <Typography variant='body2' textAlign={'center'}>{ts.water_level_state ? ts.water_level_state : '-'}</Typography>
                  </StyledTableCell>
                  <StyledTableCell color={grey[900]} sx={{p: 1}}>
                    <Typography variant='body2' textAlign={'center'}>{ts.pumps === undefined || ts.pumps.length === 0 ? '-' : ts.pumps.map(p => p.PumpState).join(', ')}</Typography>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
